import * as Mtype from './mutations-type.js'
import Outil from '@/assets/js/utils.js'
const OfflineModeFunction = ['Scte', 'SpotCoverOn', 'OverlaySwitch', 'PlugFlow', 'startingUpHint', 'disableButton']
const CloneModeFunction = ['Event', 'Template', 'VideoAdd', 'VideoEdit', 'VideoDelete', 'Logo', 'Crawl', 'Scte', 'Singular', 'SpotCoverOn']
const forbiddenFunction = ['videoAdd', 'videoEdit', 'videoDelete', 'eventEdit', 'eventDelete']
export default {
  [Mtype.SELECTSOURCE] (state, data) {
    state.selectedSource = data
  },
  // 设置logo的位置
  [Mtype.SET_LOGO_POSITION] (state, data) {
    state.LogoMessage = data
  },
  // 获取设备信息
  [Mtype.GET_FACILITY_MESSAGE] (state, data) {
    state.WSGetFacility = data
  },
  ListFeatures (state, data) {
    state.listFeatures = data
  },
  BeEditingMessage (state, data) {
    state.BeEditingMessage = data
  },
  // Clone禁止控制
  CloneDisabled (state) {
    const cloneRole = Outil.getProgramReceiver('cloneRole')
    const modeType = Outil.getProgramReceiver('modeType')
    // clone管理
    let Disabled = false
    if (cloneRole == 2) {
      Disabled = true
    }
    CloneModeFunction.forEach(key => {
      state.CloneDisabled[key] = Disabled
    })
    // disable管理
    let OfflineMode = false
    if (modeType == 2) {
      OfflineMode = true
    }
    state.CloneDisabled.disableButton = OfflineMode
    state.CloneDisabled.startingUpHint = OfflineMode
    // 角色管理
    const permission = state.permissionList.filter(item => {
      return item.roles === state.UserChannelPermission
    })[0]
    if (permission) {
      const config = state.PermissionConfig[permission.name] || []
      config.forEach(key => {
        state.CloneDisabled[key] = true
      })
    }
  },
  // 多选文件拖拽
  SetPitchOnFileList (state, data) {
    const key = data.id
    let PitchOnFileList = JSON.parse(JSON.stringify(state.PitchOnFileList))
    if (JSON.stringify(data) == '{}') {
      PitchOnFileList = {}
    } else {
      if (PitchOnFileList[key]) {
        delete PitchOnFileList[key]
      } else {
        PitchOnFileList[key] = data
      }
    }
    state.PitchOnFileList = PitchOnFileList
  },
  // 用户权限获取
  UserChannelPermission (state, data) {
    state.UserChannelPermission = data
  },
  setLBandInfo (state, data) {
    state.lBandInfo = data
  },
  // ctrl+c 复制的事件
  setCtrlCopyEvent (state, data) {
    const CtrlCopyEvent = JSON.parse(JSON.stringify(data))
    console.log(CtrlCopyEvent, 'kkkkk')
    state.CtrlCopyEvent = CtrlCopyEvent
  }
}
